import api from 'api';

export const loadUsers = api('GET /api/influencers-channels/fields/users');

export const loadActiveUsers = api(
  'GET /api/influencers-channels/fields/users/active'
);

export const loadSocialMediaPlatforms = api(
  'GET /api/influencers-channels/fields/social-media-platforms'
);

export const loadCountries = api(
  'GET /api/influencers-channels/fields/countries'
);

export const loadCategories = (params) =>
  api('GET /api/influencers-channels/fields/categories')(params);

export const loadSubCategories = api(
  'GET /api/influencers-channels/fields/sub-categories'
);

export const loadAgencies = api(
  'GET /api/influencers-channels/fields/agencies'
);

export const loadInfluencers = api(
  'GET /api/influencers-channels/fields/influencers'
);
